import React, { ReactNode, useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { Main } from '../../layouts';
import Container from '../Container';

interface TourLayoutProps {
    Sidebar: ReactNode;
    tabs: {
        label: string;
        content: ReactNode;
    }[];
    floatingComponents?: ReactNode;
}

export default function TourLayoutContainer({ Sidebar, tabs, floatingComponents }: TourLayoutProps) {
    const [view, setView] = useState(0);

    return (
        <Main>
            <Container>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: 2,
                        width: '100%',
                        mx: 'auto',
                    }}
                >
                    <Box
                        sx={{
                            width: { xs: '100%', sm: '33%' },
                            minWidth: 280,
                            flexShrink: 1,
                            position: { sm: 'sticky' },
                            top: 80,
                            alignSelf: 'flex-start',
                        }}
                    >
                        {Sidebar}
                    </Box>
                    <Box sx={{ flex: 1, maxWidth: '700px' }}>
                        <Tabs
                            value={view}
                            onChange={(e, newValue) => setView(newValue)}
                            sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
                        >
                            {tabs.map((tab, index) => (
                                <Tab key={index} label={tab.label} />
                            ))}
                        </Tabs>

                        {tabs.map((tab, index) => (
                            <Box
                                key={index}
                                sx={{ display: view === index ? 'block' : 'none' }}
                            >
                                {tab.content}
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Container>

            {/* General floating components, such as dialogs */}
            {floatingComponents}
        </Main>
    );
}
